import React, { type ComponentProps } from 'react';
import defaultsDeep from 'lodash.defaultsdeep';

import { Navbar } from './components';
import { type CooperationProps } from './components/Cooperation';

type ReactImage = ComponentProps<'img'>;

interface InitAPI {
  login?: () => Promise<unknown>
  logout?: () => Promise<unknown>
  getToken?: () => Promise<string>

  logo?: {
    href?: string
    desktop?: ReactImage
    mobile?: ReactImage
  }

  show?: {
    toggles?: {
      login?: boolean;
      claim?: boolean;
      logout?: boolean;
      notifications?: boolean;
      menu?: boolean;
    }
  }

  addons?: {
    text?: string
    logo?: ReactImage
  }
}

const defaults: InitAPI = {
  login: window?.stbauth?.login,
  logout: window?.stbauth?.logout,
  getToken: window?.stbauth?.getToken,
  logo: {
    desktop: {
      src: 'https://assets-t.storebrand.no/logos/beta/storebrand-logo-desktop.svg',
      alt: 'Storebrand Logo',
    },
    mobile: {
      src: 'https://assets-t.storebrand.no/logos/beta/storebrand-logo-only.svg',
      alt: 'Storebrand Logo',
    },
  },
  show: {
    toggles: {
      login: true,
      logout: false,
      notifications: true,
      menu: true,
      claim: true,
    },
  },
  addons: undefined,
};

async function init(
  id = 'navbar-root',
  props: Partial<InitAPI> = defaults,
) {
  const mergedProps: InitAPI = defaultsDeep(props, defaults);

  const { version } = await import('react/package.json');

  const container = document.getElementById(id);

  const cooperation = mergedProps.addons
    ? {
      organization: mergedProps.addons.logo?.alt || 'Undefined',
      logo: {
        src: mergedProps.addons.logo?.src || '',
        height: mergedProps.addons.logo?.height || '24px',
      },
    } as CooperationProps
    : undefined;

  const App = (
    <Navbar
      login={mergedProps.login}
      logout={mergedProps.logout}
      getToken={mergedProps.getToken}
      show={mergedProps.show?.toggles}
      logo={mergedProps.logo}
      cooperation={cooperation}
    />
  );

  if (version.startsWith('18')) {
    const { createRoot } = await import('react-dom/client');

    const root = createRoot(container!);

    root.render(App);
  } else {
    const { render } = await import('react-dom');

    render(
      App,
      document.getElementById(id),
    );
  }
}

export default init;
